import React from "react";
import PropTypes from "prop-types";
// import cx from "classnames";
import { Icon, Modal, List, Statistic, Col } from "antd";
import { OrderedMap } from "immutable";
// import { Table } from "components";
import { 
    // CASE_ACTIONS,
    CASE_CATEGORY_TYPES
} from "../constants";
import moment from "moment";
import { formatCurrency } from "utilities";

/*eslint:disable-displayname*/
const renderAction = (actionHandler, record) => {
    // const CaseActionMenu = (_, record) => {
    return (
        <div className={"d-flex align-items-center"}>
            <a className={"p-5"} rel="noopener noreferrer" href="javascript:void(0)" onClick={actionHandler.bind(null, 3, record.id)}>
                <Icon type="redo"/>&nbsp;&nbsp;Renew
            </a>
            <a className={"p-5"} rel="noopener noreferrer" href="javascript:void(0)" onClick={actionHandler.bind(null, 2, record.id)}>
                <Icon type={"plus-square"}/>&nbsp;&nbsp;Enhance
            </a>
            <a className={"p-5"} rel="noopener noreferrer" href="javascript:void(0)" onClick={actionHandler.bind(null, 4, record.id)}>
                <Icon type={"plus-square"}/>&nbsp;&nbsp;Amendment
            </a>
        </div>
    );
    // };
    // CaseActionMenu.displayName="CaseActionMenu";
    // return <CaseActionMenu/>;
};

// const renderActionDropdown = actionHandler => {
//     const CaseActionMenu = (_,record) => {
//         const menu =  (<Menu>
//             <Menu.Item>
//                 <a rel="noopener noreferrer" href="javascript:void(0)" onClick={actionHandler.bind(null, 3, record.id)}>
//                     <Icon type="redo"/>&nbsp;&nbsp;Renew
//                 </a>
//             </Menu.Item>
//             <Menu.Item>
//                 <a rel="noopener noreferrer" href="javascript:void(0)" onClick={actionHandler.bind(null, 2, record.id)}>
//                     <Icon type={"plus-square"}/>&nbsp;&nbsp;Enhance
//                 </a>
//             </Menu.Item>
//             <Menu.Item>
//                 <a rel="noopener noreferrer" href="javascript:void(0)" onClick={actionHandler.bind(null, 4, record.id)}>
//                     <Icon type={"plus-square"}/>&nbsp;&nbsp;Amendment
//                 </a>
//             </Menu.Item>
//         </Menu>);
//         return (
//             <Dropdown overlay={menu}>
//                 {/* <a className="ant-dropdown-link" href="javascript:void(0)" onClick={actionHandler.bind(null,CASE_ACTIONS.VIEW_CASE, record.id)}>
//                     View Details&nbsp;&nbsp;<Icon type="down-circle"/>
//                 </a> */}
//                 <Icon type="ellipsis" />
//             </Dropdown>
//         );
//     };
//     CaseActionMenu.displayName="CaseActionMenu";
//     return CaseActionMenu;
// };

/*eslint:enable-displayname*/


const TABLE_COLUMNS = new OrderedMap({
    // id: {
    //     title: "Id",
    //     key: "id",
    //     dataIndex: "id",
    //     width: 120
    // },
    case_type: {
        title: "Type",
        key: "case_type",
        dataIndex: "case_type",
        // width: 120,
        render: _ => CASE_CATEGORY_TYPES.findKey(__ => __ === _)
    },
    sanction_limit: {
        title: "Limit",
        key: "sanction_limit",
        dataIndex: "sanction_limit",
        // width: 120,
        render: _ => formatCurrency(_, true)
    },
    current_stage: {
        title: "Stage",
        key: "current_stage",
        dataIndex: "current_stage",
        // width: 150,
        render: (_, record) => record &&
            record.current_case_task[0] &&
            record.current_case_task[0].this_stage &&
            record.current_case_task[0].this_stage.stage_name
    },
    create_date: {
        title: "Creation",
        key: "create_date",
        dataIndex: "create_date",
        render: _ => _ && moment(_).format("DD/MM/YYYY"),
        // width: 100
    },
    submission_date: {
        title: "Submission",
        key: "submission_date",
        dataIndex: "submission_date",
        render: _ => _ && moment(_).format("DD/MM/YYYY"),
        // width: 100
    },
    sanction_date: {
        title: "Sanction",
        key: "sanction_date",
        dataIndex: "sanction_date",
        render: _ => _ && moment(_).format("DD/MM/YYYY"),
        // width: 100
    },
    sales_manager_user: {
        title: "Sales Manager",
        key: "sales_manager_user",
        dataIndex: "sales_manager_user",
        render: _ => _ && _.full_name
    },
    bank: {
        title: "Lending Partner",
        key: "bank",
        dataIndex: "bank",
        render: _ => _ && _.short_name
    }
});




class CaseHistoryTable extends React.Component {
    renderRowDetails() {
        return "this will render the row details";
    }
    handleMenuClick = (action, key) => {
        const modal = Modal.confirm();
        modal.update({
            title: "Are you sure?",
            content: "This will go to the Sales Cordinator.",
            onOk: () => this.props.updateCaseType(key, action),
            onCancel: () => {},
            okText: "Yes",
            cancelText: "No"
        });
    }

    // actionDropdown = renderActionDropdown(this.handleMenuClick);
    columns = TABLE_COLUMNS.set(["action"],{
        title: "Action",
        key: "action",
        dataIndex: "action",
        width: 150,
        render: this.actionDropdown
    });

    renderListItem = (_, key) => {
        return (
            <List.Item
                key={key}
                className={
                    "border-none flex-column padless-card mt-10 schemes-detail p-10 bg-white"
                }
            >
                <div 
                    className={"d-flex m-5 p-5 flex-row w-100 justify-content-space-between align-items-center"}
                    style={{
                        backgroundColor: "#fafafa"
                    }}
                >
                    <Statistic
                        valueStyle={{
                            fontSize: "16px",
                            fontWeight: 500
                        }}
                        className={"stat-title"}
                        title="Case ID" 
                        value={_.id} 
                    />
                    {renderAction(this.handleMenuClick, _)}
                </div>
                <div className={"d-flex m-5 p-5 flex-row w-100 flex-wrap"}>
                    <Col span={24}>
                        {TABLE_COLUMNS.map((__, k) => {
                            return (
                                <Col className={"mt-10 mb-10"} key={k} span={6}>
                                    <Statistic 
                                        valueStyle={{
                                            fontSize: "16px",
                                            fontWeight: 600
                                        }} 
                                        title={__.title} 
                                        value={__.render(_[k], _)}
                                    />
                                </Col>
                            );
                        }).toList().toArray()}
                    </Col>
                </div>
            </List.Item>
        );
    }
    
    render() {
        return (
            <Col span={18} offset={3}>
                <List 
                    border={false}
                    className={"border-none"}
                    header={null}
                    footer={null}
                    dataSource={this.props.cases}
                    renderItem={this.renderListItem}
                />
            </Col>
            // <Table
            //     showHeader={false}
            //     showTopSection={false}
            //     columns={this.columns}
            //     className={cx("padless-table")}
            //     checkedColumns={[]}
            //     data={this.props.cases}
            //     keyFilter={"id"}
            //     showBulkDropdown={false}
            //     noRowSelection={true}
            //     // expandedRowRender={this.renderRowDetails}
            //     fixedColsRight={["action"]}
            // />
        );
    }
}


CaseHistoryTable.propTypes = {
    cases: PropTypes.object,
    caseActionHandler: PropTypes.func,
    updateCaseType: PropTypes.func
};

export default CaseHistoryTable;